var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 8.66897,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1003",
    width: 118.33532,
    height: 29.890099,
    x: -5.0497956,
    y: 20.21538,
    ry: 14.945049,
    rx: 16.117851,
    transform: "matrix(0.98971647,-0.14304306,0.19309181,0.98118069,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 7.70664,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1003-3",
    width: 91.022987,
    height: 30.710543,
    x: 28.390116,
    y: -78.252258,
    ry: 15.355271,
    transform: "matrix(-0.00459934,0.99998942,-0.99999816,-0.00191726,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9800",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path234",
    d: "M 115.53694,20.46642 A 48.247322,22.843233 0 0 1 71.314649,43.503763 48.247322,22.843233 0 0 1 19.623588,24.264815"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path2759",
    d: "M 64.701286,18.148449 A 12.254138,12.254138 0 0 1 54.304839,31.979172 12.254138,12.254138 0 0 1 40.441203,21.626654 12.254138,12.254138 0 0 1 50.749688,7.7302455 12.254138,12.254138 0 0 1 64.678729,17.994593"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9800",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 0.692826,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path2759-2",
    d: "M 94.442342,8.3488595 A 8.8807335,8.8807335 0 0 1 86.907902,18.372165 8.8807335,8.8807335 0 0 1 76.860744,10.86956 8.8807335,8.8807335 0 0 1 84.331437,0.79865196 8.8807335,8.8807335 0 0 1 94.425995,8.2373584"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9800",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 4.74054,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path2759-2-2",
    d: "m 85.147854,46.167621 a 9.5833006,9.5833006 0 0 1 -8.130501,10.816263 9.5833006,9.5833006 0 0 1 -10.842002,-8.096146 9.5833006,9.5833006 0 0 1 8.06171,-10.867632 9.5833006,9.5833006 0 0 1 10.893152,8.027193"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 86.231743,10.165531 77.234664,49.074975",
    id: "path4513"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 60.759493,29.32814 76.066212,47.555988",
    id: "path4759"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 64.615385,17.526777 84.712756,9.4644596",
    id: "path4761"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff9800",
      strokeWidth: 2.0731,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "path2759-2-2-3",
    d: "M 88.459355,45.440058 A 12.904001,12.880713 0 0 1 81.259065,58.842346 12.904001,12.880713 0 0 1 66.281998,56.053997 12.904001,12.880713 0 0 1 64.405835,40.961905"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a604a6e61947bd0f7b2e86cc2b680f29.svg";
export { ForwardRef as ReactComponent };